// Components
import GDImageViewer from "../components/shared/GDImageViewer";
import Hero from "../components/layout/Hero";
import TimeTableImage from "../components/timetable/TimeTableImage";

// Assets
import "../assets/styles/timetable.css";
import heroImg from "../assets/images/timetable/hero.jpg";

// Hooks
import { useTranslation } from "../hooks/useTranslation";

export default function TimeTable(params) {

    const t = useTranslation();

    return (
        <>
            <section id="timetableSection">
                <Hero
                    bgImage={heroImg}
                    title={t("timetable.title")}
                />

                <GDImageViewer
                    className="timetableCard"
                    data={{
                        dirId: process.env.REACT_APP_GD_TIMETABLE_DIR_ID,
                        gkey: process.env.REACT_APP_GD_API_KEY,
                        options: {
                            onClick: { modal: true },
                            gridOriginal: true,
                            hover: true,
                            showDate: true,
                            loadingText: t("timetable.loading"),
                        },
                    }}
                    ImageComponent={TimeTableImage}
                />
            </section >
        </>
    )
}